import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t7 in e) "default" !== _t7 && {}.hasOwnProperty.call(e, _t7) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t7)) && (i.get || i.set) ? o(f, _t7, i) : f[_t7] = e[_t7]); return f; })(e, t); }
import { c as _c } from "react-compiler-runtime";
import React, { Suspense } from 'react';
import useI18nString from '@nike/shop-apis/assets/i18n/dotcom-cart/use-query';
import { useIsMobile } from '@nike/shop-apis/css/hooks';
import FooterSlot from './FooterSlot';
import useShopDialogStore from "../../store/shop-dialog/use-store";
import Modal from "../modal/Modal";
import { LOCATION_TYPES } from "../../constants";
import FlexBox from "../../styles/components/FlexBox";
var LazyTextStyled = /*#__PURE__*/React.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('@nike/nike-design-system-components'));
  }).then(function (_ref) {
    var TextStyled = _ref.TextStyled;
    return {
      "default": TextStyled
    };
  });
});
var LazyEDDContent = /*#__PURE__*/React.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./edd-content/EDDContent'));
  });
});
var LazyBOPISContent = /*#__PURE__*/React.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./bopis-content/BOPISContent'));
  });
});
var BOPIS_EDD_Modal = function BOPIS_EDD_Modal() {
  var $ = _c(28);
  var fulfillmentType = useShopDialogStore(_temp);
  var isModalOpen = useShopDialogStore(_temp2);
  var showPickupIneligibleMessage = useShopDialogStore(_temp3);
  var closeDialog = useShopDialogStore(_temp4);
  var titleParams;
  if (showPickupIneligibleMessage) {
    var _t;
    if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
      _t = {
        stringKey: "pickupIneligibleModalTitle",
        primaryValue: "Store Pickup Unavailable",
        description: "Pickup ineligible modal title"
      };
      $[0] = _t;
    } else {
      _t = $[0];
    }
    titleParams = _t;
  } else {
    if (fulfillmentType === "SHIP") {
      var _t2;
      if ($[1] === Symbol["for"]("react.memo_cache_sentinel")) {
        _t2 = {
          stringKey: "shippingOptions",
          primaryValue: "Shipping Options",
          description: "Shipping options header"
        };
        $[1] = _t2;
      } else {
        _t2 = $[1];
      }
      titleParams = _t2;
    } else {
      if (fulfillmentType === "PICKUP") {
        var _t3;
        if ($[2] === Symbol["for"]("react.memo_cache_sentinel")) {
          _t3 = {
            stringKey: "pickupOfferingsTitle",
            primaryValue: "Select Pickup Location",
            description: "Pickup offerings title to display to user"
          };
          $[2] = _t3;
        } else {
          _t3 = $[2];
        }
        titleParams = _t3;
      }
    }
  }
  var title = useI18nString(titleParams);
  var isMobile = useIsMobile();
  var dataAutomation = "shop-dialog";
  if (fulfillmentType === "PICKUP") {
    dataAutomation = "BOPIS-modal";
  } else {
    if (fulfillmentType === "SHIP") {
      dataAutomation = "EDD-modal";
    }
  }
  var t0;
  if ($[3] !== closeDialog) {
    t0 = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e === null || e === void 0 || e.preventDefault();
              closeDialog();
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function t0(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    $[3] = closeDialog;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  var onClose = t0;
  var t1;
  if ($[5] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      stringKey: "pickupIneligibleModalDetail",
      primaryValue: "This product is not eligible for store pickup. If it is in your bag when you check out, you will not be able to choose store pickup for any items in your order.",
      description: "Details regarding ineligible store pickup item affecting cart"
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  var pickupIneligibleModalDetail = useI18nString(t1);
  var lazyModalContent = null;
  if (showPickupIneligibleMessage) {
    var _t4;
    if ($[6] !== pickupIneligibleModalDetail) {
      _t4 = /*#__PURE__*/React.createElement(LazyTextStyled, {
        appearance: "body1"
      }, pickupIneligibleModalDetail);
      $[6] = pickupIneligibleModalDetail;
      $[7] = _t4;
    } else {
      _t4 = $[7];
    }
    lazyModalContent = _t4;
  } else {
    if (fulfillmentType === LOCATION_TYPES.ship) {
      var _t5;
      if ($[8] === Symbol["for"]("react.memo_cache_sentinel")) {
        _t5 = /*#__PURE__*/React.createElement(LazyEDDContent, null);
        $[8] = _t5;
      } else {
        _t5 = $[8];
      }
      lazyModalContent = _t5;
    } else {
      if (fulfillmentType === LOCATION_TYPES.pickup) {
        var _t6;
        if ($[9] === Symbol["for"]("react.memo_cache_sentinel")) {
          _t6 = /*#__PURE__*/React.createElement(LazyBOPISContent, null);
          $[9] = _t6;
        } else {
          _t6 = $[9];
        }
        lazyModalContent = _t6;
      }
    }
  }
  var t2;
  if ($[10] === Symbol["for"]("react.memo_cache_sentinel")) {
    t2 = {
      stringKey: "label.close",
      primaryValue: "Close",
      description: "Modal close button accessibility string"
    };
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  var closeButtonAriaLabel = useI18nString(t2);
  var t3 = isMobile && !showPickupIneligibleMessage ? "fullscreen" : "base";
  var t4;
  if ($[11] !== dataAutomation) {
    t4 = {
      "data-automation": dataAutomation
    };
    $[11] = dataAutomation;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  var t5;
  if ($[13] !== fulfillmentType || $[14] !== onClose || $[15] !== showPickupIneligibleMessage) {
    t5 = {
      FooterSlot: /*#__PURE__*/React.createElement(FooterSlot, {
        showPickupIneligibleMessage: showPickupIneligibleMessage,
        fulfillmentType: fulfillmentType,
        onClose: onClose
      })
    };
    $[13] = fulfillmentType;
    $[14] = onClose;
    $[15] = showPickupIneligibleMessage;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  var t6;
  if ($[17] !== lazyModalContent) {
    t6 = /*#__PURE__*/React.createElement(FlexBox, {
      flexDirection: "column"
    }, /*#__PURE__*/React.createElement(Suspense, {
      fallback: null
    }, lazyModalContent));
    $[17] = lazyModalContent;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  var t7;
  if ($[19] !== closeButtonAriaLabel || $[20] !== isModalOpen || $[21] !== onClose || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== title) {
    t7 = /*#__PURE__*/React.createElement(Modal, {
      appearance: t3,
      isOpen: isModalOpen,
      onClose: onClose,
      onOverlayClick: onClose,
      className: "dialog-container",
      modalContainerCompProps: t4,
      modalCloseAriaLabel: closeButtonAriaLabel,
      title: title,
      slots: t5
    }, t6);
    $[19] = closeButtonAriaLabel;
    $[20] = isModalOpen;
    $[21] = onClose;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = title;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
};
export default BOPIS_EDD_Modal;
function _temp(state) {
  return state.fulfillmentType;
}
function _temp2(state_0) {
  return state_0.isModalOpen;
}
function _temp3(state_1) {
  return state_1.showPickupIneligibleMessage;
}
function _temp4(state_2) {
  return state_2.closeDialog;
}